module.exports = __webpack_public_path__ + "8e3fe60c0824e7d719bd45b222f3d74d.svg";